import {getCalendarMatrix} from "@ui/datePicker/helpers/helpers";
import moment from "moment";
import React from 'react'
import {sx} from './sx'
import {Stack, Typography} from "@mui/material";
import {classNames} from "@helpers/classNames";

const DaysDatePicker = ({value, onChange}) => {

    const days = React.useMemo(() => {
        if (!value) {
            return []
        }
        return getCalendarMatrix(new Date(moment(value)))
    }, [value])


    const head = moment.weekdaysMin(true).map((item) => {
        return (
            <Typography
                key={item}
                sx={sx.item}
                variant={'body2'}
            >
                {item}
            </Typography>
        )
    })

    const list = days?.length >= 1 && days.map((row,index) => {
        const rows = row?.map((col) => {
            const active = moment(value).format("DD.MM.YYYY") === moment(col).format("DD.MM.YYYY")
            const currentDay = moment(new Date()).format("DD.MM.YYYY") === moment(col).format("DD.MM.YYYY")
            const currentMoth = moment(value).isSame(col, "month");
            const day = moment(col).format('D');
            const month = moment(col).month()
            const year = moment(col).year()
            const onClick = () => {
                const date = moment(value)?.year(year).month(month).date(day).format()
                onChange(date)
            }
            return (
                <Typography
                    key={day}
                    onClick={onClick}
                    className={classNames(active && 'active', currentDay && 'currentDay', currentMoth && 'currentMoth')}
                    sx={sx.item}
                    variant={'body2'}
                >
                    {day}
                </Typography>
            )
        })
        return (
            <Stack
                key={index}
                direction={'row'}
            >
                {rows}
            </Stack>
        )
    })
    return (
        <Stack gap={1}>
            <Stack
                direction={'row'}
            >
                {head}
            </Stack>
            {list}
        </Stack>
    );
};

export default DaysDatePicker